import React from 'react';
import './Footer.css';

function Footer() {
  return (
    <div className='footer'>
        <div className='d-flex flex-column flex-sm-row justify-content-between align-items-center'>
            <a href="https://www.playpokigames.com/privacy-policy" className="h6">Privacy-policy</a>
            <a href="https://www.playpokigames.com" className="h6">playpokigames.com</a>
        </div>
    </div>
  )
}

export default Footer